<template>
  <div style="background-color: #f4fbff">
    <audio ref="ringing" autoplay playsinline></audio>
    <Header
      :leftArrow="this.leftArrow"
      :leftText="''"
      @leftClick="onClickLeft"
      :rightIcons="false"
    >
    </Header>
    <div class="mypage_home" v-show="isInfoBack">
      <div class="wrap mypage_wrap">
        <van-form ref="form" style="margin: 0 0 10px 0" v-if="user.type == '5'">
          <van-button
            round
            type="success"
            color="#3B82C4"
            size="small"
            @click="reloadPage"
            >リフレッシュ</van-button
          >
          <van-button
            v-if="isAndroidStg"
            round
            type="info"
            color="#3B82C4"
            size="small"
            @click="showLogDialog"
            >再起動ログ</van-button
          >

          <van-button
            v-if="isIosStg"
            round
            type="info"
            color="#3B82C4"
            size="small"
            @click="showWSLogDialog"
            >websocketログ</van-button
          >

        </van-form>
        <van-form ref="form">
          <div
            class="mypage_id mypage_box"
            @click="goToPage('userInfo')"
            style="margin: 0"
          >
            <div class="mypage_id-link">
              <p class="mypage_id-name">{{ userInfo.name }}</p>
              <p class="mypage_id-num">ID：{{ userInfo.login_id }}</p>
            </div>
          </div>
        </van-form>

        <van-form
          class="form_style"
          ref="form"
          v-if="this.user.type == '5'"
          style="display: none"
        >
          <van-cell-group inset class="cell_style">
            <van-field
              label-width="200px"
              is-link
              readonly
              name="binahData"
              label="ビナーデータ"
              @click="goToPage('binahData')"
            >
            </van-field>
          </van-cell-group>
        </van-form>

        <van-form
          class="form_style"
          ref="form"
          v-if="this.user.type == '4'"
          style="display: none"
        >
          <van-cell-group inset class="cell_style">
            <van-field
              label-width="200px"
              is-link
              readonly
              name="PatientListBinah"
              label="ビナーデータ"
              @click="goToPage('PatientListBinah')"
            >
            </van-field>
          </van-cell-group>
        </van-form>

        <van-form
          validate-first
          validate-trigger="onChange"
          class="form_style"
          ref="formA"
        >
          <van-cell-group inset class="cell_style">
            <van-field
              label-width="200px"
              name="switch"
              input-align="right"
              label="シンプルユーザー自動受話"
              v-if="this.user.type == '4'"
            >
              <template #input>
                <van-switch
                  v-model="checkInfo"
                  size="20"
                  @change="handleChangeUserInfo('answer_flg', $event)"
                  active-color="#3B82C4"
                />
              </template>
            </van-field>

            <van-field
              name="switch"
              input-align="right"
              label="自動受話"
              v-else
            >
              <template #input>
                <van-switch
                  v-model="checkInfo"
                  size="20"
                  @change="handleChangeUserInfo('answer_flg', $event)"
                  active-color="#3B82C4"
                />
              </template>
            </van-field>

            <van-field
              name="switch"
              input-align="right"
              label="コールアイコンの表示"
              label-width="50%"
              v-show="this.user.type == '5'"
            >
              <template #input>
                <van-switch
                  v-model="showCallIcon"
                  size="20"
                  @change="toggleShowCallIcon"
                  active-color="#3B82C4"
                />
              </template>
            </van-field>
            <van-field
              name="switch"
              input-align="right"
              label="フルスクリーンコール"
              label-width="50%"
              v-show="this.user.type == '5'"
            >
              <template #input>
                <van-switch
                  v-model="is_full_screen_call"
                  size="20"
                  @change="handleChangeUserInfo('is_full_screen_call', $event)"
                  active-color="#3B82C4"
                />
              </template>
            </van-field>
            <van-field
              name="switch"
              input-align="right"
              label="ダークモード"
              v-show="this.user.type == '5'"
            >
              <template #input>
                <!-- <van-switch
                  v-model="darkMode"
                  size="20"
                  @change="toggleDarkMode"
                  active-color="#3B82C4"
                /> -->
                <van-radio-group
                  @change="toggleDarkMode"
                  v-model="darkModeType"
                  direction="horizontal"
                >
                  <van-radio name="on">ON</van-radio>
                  <van-radio name="off">OFF</van-radio>
                  <van-radio name="auto">自動</van-radio>
                </van-radio-group>
              </template>
            </van-field>
            <van-field
              v-show="checkInfo"
              name="validatorAutoAnswerTime"
              input-align="right"
              label="応答時間"
            >
              <template #input>
                <van-stepper
                  v-model="userInfo.auto_answer_time"
                  @change="handleChangeUserInfo('auto_answer_time', $event)"
                  integer
                  input-width="40px"
                  min="0"
                  max="60"
                  :before-change="handleBeforeChange"
                />秒
              </template>
            </van-field>
            <van-field
              name="switch"
              input-align="right"
              label="待受画面時間表示"
              label-width="50%"
              v-if="this.user.type == '5'"
            >
              <template #input>
                <van-switch
                  size="20"
                  active-color="#3B82C4"
                  v-model="checkTimeShowFlg"
                  @change="handleChangeUserInfo('time_show_flg', $event)"
                />
              </template>
            </van-field>
            <van-field
              v-if="this.user.type == '5'"
              v-show="checkTimeShowFlg"
              @click="goToPage('timeDisplaySize')"
              is-link
              readonly
              class="time-display-size-field"
              name="timeShowFontSize"
              label="待受画面時間表示の大きさの変更"
              label-width="80%"
            />
            <van-field
              v-if="this.user.type == '5'"
              @click="goToPage('fullScreenCallDisplaySize')"
              is-link
              readonly
              class="time-display-size-field"
              name="fullScreenCallFontSize"
              label="メッセージ画面の文字の大きさの変更"
              label-width="80%"
            />
            <van-field
              v-if="this.user.type == '5'"
              @click="goToPage('waitBackground')"
              is-link
              readonly
              name="goChooseWaitBackground"
              label="待受画面"
            >
            </van-field>
            <van-field
              @click="goToPage('patientWaitBackground')"
              v-if="this.user.type == '4'"
              label-width="200px"
              is-link
              readonly
              name="goChoosePatientWaitBackground"
              label="シンプルユーザー待受画面"
            >
            </van-field>
            <van-field
              @click="goToPage('authentication')"
              is-link
              readonly
              name="position_main_name"
              label="２段階認証"
            >
            </van-field>
            <van-field
              v-if="this.user.type == '4'"
              label-width="200px"
              name="switch"
              input-align="right"
              label="切断なし"
            >
              <template #input>
                <van-switch
                  v-model="noAnswerFlg"
                  @change="handleChangeUserInfo('no_answer_flg', $event)"
                  size="20"
                  active-color="#3B82C4"
                />
              </template>
            </van-field>
            <van-field
              v-show="userInfo.type === '4' && !noAnswerFlg"
              input-align="right"
              label="不在自動切断"
            >
              <template #input>
                <van-stepper
                  v-model="userInfo.no_answer_time"
                  @change="handleChangeUserInfo('no_answer_time', $event)"
                  integer
                  input-width="40px"
                  min="0"
                  max="60"
                  :before-change="handleBeforeChange"
                />秒
              </template>
            </van-field>
            <van-field
              v-if="this.user.type == '4'"
              label-width="200px"
              name="switch"
              input-align="right"
              label="ボタン切断なし"
            >
              <template #input>
                <van-switch
                  v-model="showCallNoAnswerFlg"
                  @change="
                    handleChangeUserInfo('show_call_no_answer_flg', $event)
                  "
                  size="20"
                  active-color="#3B82C4"
                />
              </template>
            </van-field>
            <van-field
              v-show="userInfo.type === '4' && !showCallNoAnswerFlg"
              input-align="right"
              label="ボタン不在自動切断"
              label-width="50%"
            >
              <template #input>
                <van-stepper
                  v-model="userInfo.show_call_no_answer_time"
                  @change="
                    handleChangeUserInfo('show_call_no_answer_time', $event)
                  "
                  integer
                  input-width="40px"
                  min="0"
                  max="60"
                  :before-change="handleBeforeChange"
                />秒
              </template>
            </van-field>
            <van-field
              style="align-items: center"
              label="バーチャル背景"
              label-width="100px"
              readonly
              v-model="filename"
            >
              <template #button>
                <van-uploader
                  accept="image/jpeg,image/png"
                  max-count="1"
                  :after-read="uploadFile"
                >
                  <van-button
                    size="small"
                    style="
                      background-color: #3b82c4;
                      color: #fff;
                      border-radius: 8px;
                    "
                    >アップロード</van-button
                  >
                </van-uploader>
              </template>
            </van-field>
            <van-field
              v-if="this.user.type == '4'"
              name="switch"
              input-align="right"
              label="インカム自動受話ON/OFF"
              label-width="200px"
            >
              <template #input>
                <van-switch
                  v-model="checkAudioBridge"
                  size="20"
                  @change="handleChangeUserInfo('audio_bridge', $event)"
                  active-color="#3B82C4"
                />
              </template>
            </van-field>
            <van-field
              v-if="this.user.type == '4'"
              name="switch"
              input-align="right"
              label="ビデオ通話時の自身の画面表示ON/OFF"
              label-width="70%"
            >
              <template #input>
                <van-switch
                  v-model="checkSelfView"
                  size="20"
                  @change="handleChangeUserInfo('self_view_flg', $event)"
                  active-color="#3B82C4"
                />
              </template>
            </van-field>
            <van-field
              @click="showIncomeDefaultTeam"
              v-if="this.user.type == '4'"
              is-link
              readonly
              label="インカムデフォルトチーム"
              label-width="200px"
            >
            </van-field>
          </van-cell-group>
        </van-form>

        <van-form class="form_style" ref="form" v-show="this.user.type == '5'">
          <van-cell-group inset class="cell_style">
            <van-field name="switch" input-align="right" label="カメラON/OFF">
              <template #input>
                <van-switch
                  v-model="checkCamera"
                  size="20"
                  @change="handleChangeUserInfo('camera_flg', $event)"
                  active-color="#3B82C4"
                />
              </template>
            </van-field>
            <van-field name="switch" input-align="right" label="音声ON/OFF">
              <template #input>
                <van-switch
                  v-model="checkAudio"
                  size="20"
                  @change="handleChangeUserInfo('audio_flg', $event)"
                  active-color="#3B82C4"
                />
              </template>
            </van-field>
            <van-field
              name="switch"
              input-align="right"
              label="ビデオ通話時の自身の画面表示ON/OFF"
              label-width="70%"
            >
              <template #input>
                <van-switch
                  v-model="checkSelfView"
                  size="20"
                  @change="handleChangeUserInfo('self_view_flg', $event)"
                  active-color="#3B82C4"
                />
              </template>
            </van-field>
          </van-cell-group>
        </van-form>

        <van-form class="form_style" ref="form">
          <van-cell-group inset class="cell_style">
            <van-field
              label-width="200px"
              is-link
              readonly
              name="userRinging"
              label="通話着信音"
              @click="goToPage('ringingChoose')"
            >
            </van-field>
            <van-field
              label-width="200px"
              is-link
              readonly
              name="userRinging"
              label="メッセージ着信音"
              @click="goToPage('ringingMsgChoose')"
            >
            </van-field>
          </van-cell-group>
        </van-form>

        <van-form class="form_style" ref="form">
          <van-cell-group inset class="cell_style">
            <van-field
              label-width="200px"
              is-link
              label="パスワードの変更"
              @click="goToPage('password')"
            ></van-field>
          </van-cell-group>
        </van-form>

        <van-form class="form_style" ref="form" v-show="user.type === '5'">
          <van-cell-group inset class="cell_style">
            <van-field
              label-width="200px"
              name="switch"
              input-align="right"
              label="見守りモード"
            >
              <template #input>
                <van-switch
                  v-model="checkMonitorOpenFlg"
                  size="20"
                  @change="handleChangeUserInfo('monitor_open_flg', $event)"
                  active-color="#3B82C4"
                />
              </template>
            </van-field>
          </van-cell-group>
          <van-cell-group inset class="cell_style" style="display: none">
            <van-field
              label-width="200px"
              is-link
              label="監視カメラ"
              @click="goToPage('monitorRoom')"
            >
            </van-field>
          </van-cell-group>
        </van-form>

        <!-- <van-form class="form_style" ref="form" v-show="this.user.type == '4'">
          <van-cell-group inset class="cell_style">
            <van-field
              label-width="200px"
              is-link
              readonly
              name="webSpeech"
              label="音声字幕"
              @click="goToPage('webSpeech')"
            >
            </van-field>
          </van-cell-group>
        </van-form> -->

        <van-form
          validate-first
          validate-trigger="onChange"
          class="form_style"
          ref="formA"
        >
          <van-cell-group inset class="cell_style">
            <van-field
              name="switch"
              input-align="right"
              label="画面固定用の自動プッシュ"
              label-width="200px"
            >
              <template #input>
                <van-switch
                  v-model="checkAutopushflg"
                  size="20"
                  @change="handleChangeUserInfo('autopush_flg', $event)"
                  active-color="#3B82C4"
                />
              </template>
            </van-field>
          </van-cell-group>
        </van-form>

        <!-- DZ認証入口を一時的に非表示
        <van-form class="form_style" ref="form" v-show="isAndroidStg">
          <van-cell-group inset class="cell_style">
            <van-field
              label-width="200px"
              is-link
              readonly
              name="dzPage"
              label="DZ認証"
              @click="goToPage('dzPage')"
            >
            </van-field>
          </van-cell-group>
        </van-form>
        -->

        <van-popup
          v-model:show="income_team_show"
          position="bottom"
          @close="closeIncomeDefaultTeam"
          :style="{ backgroundColor: 'white', height: '50%' }"
        >
          <div class="mypage-income-btnArea">
            <div @click="closeIncomeDefaultTeam">キャンセル</div>
            <div @click="saveIncomeDefaultTeam">確認</div>
          </div>
          <div class="mypage-income-contentArea">
            <van-radio-group v-model="userInfo.bridge_default_team">
              <van-cell-group>
                <van-cell
                  v-for="(item, index) in team_list"
                  clickable
                  :key="index"
                  :title="item.group_name"
                  @click="toggleDefaultTeam(item.team_id)"
                >
                  <template #right-icon>
                    <van-radio :name="item.team_id" />
                  </template>
                </van-cell>
              </van-cell-group>
            </van-radio-group>
          </div>
        </van-popup>
      </div>
    </div>
    <Footer />

    <!-- 使用插槽定义对话框内容 -->
    <van-dialog v-model:show="isLogDialogVisible" title="ログ" theme="round-button">
      <div class="log-container" v-html="formatLogs()"></div>
    </van-dialog>

    <van-dialog v-model:show="isWSLogDialogVisible" title="websocketログ" theme="round-button">
      <div class="log-container" v-html="formatWSLogs()"></div>
    </van-dialog>
    
  </div>
</template>

<script>
import { GetUserDetails, UpdateUser, uploadBackground } from "@/services/user";
import { GetRingingList } from "@/services/ringing";
import { Toast } from "vant";
import "vant/es/toast/style";
import "vant/es/dialog/style";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import _ from "lodash";
import { RefreshUserInfo } from "@/services/login";
import { GetTeamList } from "@/services/team";
import lrz from "lrz";

export default {
  data() {
    return {
      value: "",
      userInfo: {},
      checkInfo: false,
      authInfo: false,
      authType: "email",
      user: {},
      leftArrow: false,
      defaultIndex: 1,
      ringColumns: [],
      isInfoBack: false,
      checkCamera: true,
      checkMonitorOpenFlg: true,
      checkAudio: true,
      checkSelfView: true,
      checkInfoPatient: false,
      checkAudioBridge: false,
      checkAutopushflg: false,
      checkTimeShowFlg: true,
      noAnswerFlg: true,
      showCallNoAnswerFlg: true,
      file: null,
      filename: "",
      //默认是自动模式
      darkModeType: "auto",
      //默认要显示call icon
      showCallIcon: true,
      isIos: true,
      // income用
      income_team_show: false,
      team_list: [],
      back_bridge_default_team: null,
      is_full_screen_call: true,
      // 添加日志数据
      restartLogs: [],
      wsLogs:[],
      isLogDialogVisible: false, // 控制对话框显示
      isWSLogDialogVisible: false, // 控制对话框显示
      isAndroidStg: window.location.href.includes("android-") && window.location.href.includes("stg-"), // 判断是否为 Android 环境
      isIosStg:window.location.href.includes("ios-") && window.location.href.includes("stg-"),
    };
  },
  components: {
    Header,
    Footer,
  },
  mounted() {
    //获取darkmode的值
    const storedDarkMode = localStorage.getItem("darkModeType");
    if (storedDarkMode) {
      this.darkModeType = storedDarkMode;
    }
    const storedShowCallIcon = localStorage.getItem("showCallIcon");
    if (storedShowCallIcon) {
      this.showCallIcon = JSON.parse(storedShowCallIcon);
    }

    this.user = JSON.parse(localStorage.getItem(process.env.VUE_APP_USER_KEY));
    console.log(this.user);
    this.initUserInfo();
    if (this.user.type == "5") {
      this.leftArrow = true;
    }
    this.iosOrAndroid();
  },
  methods: {
    restartAndroidApp() {
      try {
        let restartLog = {
          restart_at: new Date(),
          status: "ok",
        };
        if (cordova.plugins && cordova.plugins.RestartPlugin) {
          console.log("RestartPlugin called to restart the app.");
          this.saveRestartLog(restartLog);
          // cordova.plugins.RestartPlugin.restartApp();
          setTimeout(()=>{cordova.plugins.RestartPlugin.restartApp();},1000)
          //添加日志
          // restartLog.status="ok";
        } else {
          restartLog.status = "error";
          this.saveRestartLog(restartLog);
          console.error("RestartPlugin is not available.");
        }
      } catch (error) {
        restartLog.status = "exception";
        this.saveRestartLog(restartLog);
        console.error(
          "An error occurred while executing the restart function:",
          error
        );
      }
    },
    reloadPage() {
      const url = window.location.href;

      if (url.indexOf("android-") !== -1) {
        this.restartAndroidApp();
      } else {
        window.location.reload();
      }
    },
    saveRestartLog(newLog) {
      const storageKey = "restartLog";
      const maxLogs = 50;

      // Get current logs from storage
      let savedLogs = JSON.parse(localStorage.getItem(storageKey)) || [];

      // Add the new log
      savedLogs.push(newLog);

      // If there are more than maxLogs, remove the oldest log
      if (savedLogs.length > maxLogs) {
        savedLogs.shift();
      }

      // Save the updated logs to storage
      localStorage.setItem(storageKey, JSON.stringify(savedLogs));
    },
    showLogDialog() {
      this.restartLogs = JSON.parse(localStorage.getItem("restartLog")) || [];
      this.isLogDialogVisible = true; // 显示对话框
    },
    showWSLogDialog(){
      this.wsLogs = JSON.parse(localStorage.getItem("wss_log")) || [];
      this.isWSLogDialogVisible = true; // 显示对话框
    },
    // 格式化日志信息
    formatLogs() {
      return this.restartLogs
        .slice() // 创建副本以避免影响原数组
        .reverse() // 倒序显示
        .map((log) => {
          const date = new Date(log.restart_at).toLocaleString("ja-JP");
          const status =
            log.status === "ok"
              ? "成功"
              : log.status === "error"
              ? "失敗"
              : "異常";
          const color = log.status === "ok" ? "green" : "red";
          return `<div style="color: ${color}; margin: 5px 5px; padding: 5px; border: 1px solid #ccc; border-radius: 4px;">${date} - ${status}</div>`;
        })
        .join("");
    },
    formatWSLogs() {
      return this.wsLogs
        .slice() // 创建副本以避免影响原数组
        .reverse() // 倒序显示
        .map((log) => {
          const date = new Date(log.at).toLocaleString("ja-JP");
          const status =
            log.status === "ok"
              ? "接続成功" // 绿色
              : log.status === "havadata"
              ? "正常" // 绿色
              : log.status === "ng"
              ? "閉じる" // 红色
              : log.status === "error"
              ? "異常" // 红色
              : log.status === "recon"
              ? "再接続開始" // 红色
              : log.status === "nodata"
              ? "無データ" // 红色
              : log.status === "reload"
              ? "reload"
              : ""; // 备用消息
          const color = log.status === "ok" || log.status === "havadata" ? "green" : "red"; // 绿色和红色
          return `<div style="color: ${color}; margin: 5px 5px; padding: 5px; border: 1px solid #ccc; border-radius: 4px;">${date} - ${status}</div>`;
        })
        .join("");
    },
    async saveIncomeDefaultTeam() {
      if (this.userInfo) {
        const detail = {
          id: this.userInfo.id,
          bridge_default_team: this.userInfo.bridge_default_team,
        };
        let res = await UpdateUser(detail);
        if (res.data.code >= 0) {
          this.back_bridge_default_team = this.userInfo.bridge_default_team;
          this.income_team_show = false;
          Toast.success("変更に成功しました");
          RefreshUserInfo().then((res2) => {
            const userInfo = res2.data.data.user;
            localStorage.setItem(
              process.env.VUE_APP_USER_KEY,
              JSON.stringify(userInfo)
            );
          });
        } else {
          Toast.fail("変更に失敗しました");
        }
      }
    },
    async closeIncomeDefaultTeam() {
      this.income_team_show = false;
      this.userInfo.bridge_default_team = this.back_bridge_default_team;
    },
    toggleDefaultTeam(selected) {
      this.userInfo.bridge_default_team = selected;
    },
    async showIncomeDefaultTeam() {
      let res = await GetTeamList();
      if (res.data.code >= 0) {
        this.team_list = res.data.data.list;
        console.log(this.team_list);
        this.back_bridge_default_team = this.userInfo.bridge_default_team;
        this.income_team_show = true;
      }
    },
    cancelChooseBg() {
      this.filename = "";
      this.file = null;
    },
    uploadFile(file) {
      if (!this.checkFileSize(file.file)) {
        return;
      }

      this.updateUserFile(file.file);
    },
    checkFileSize(file) {
      const isTooLarge = file.size / 1024 / 1024 > 5;
      console.log(isTooLarge);
      if (isTooLarge) {
        this.$toast("5M以下のサイズの画像をアップロードしてください");
        return false;
      }

      return true;
    },
    compressImg(file, quality) {
      lrz(file, { quality: quality }) //设置压缩参数，quality为压缩质量，范围0-1，数值越小压缩后的图片越模糊
        .then(async (rst) => {
          // 处理成功会执行
          console.log(rst);
          // 此时图片已经压缩完毕，可以通过以下方法获取压缩后的base64、blob、file等数据
          // rst.base64为压缩后图片的base64数据
          // rst.file为压缩后的file对象，可以用于文件上传或者其他需要使用file对象的地方
          // rst.blob为压缩后的blob对象，可以用于文件上传或者formdata的使用
          // rst.origin为未压缩前的file对象，在这个对象的属性中，我们能够看到所有的文件的信息
          // this.upload(rst.file); 这里执行后台上传的函数
          let com_file = rst.file;
          let formData = new FormData();
          formData.append("file", com_file, file.name);
          await uploadBackground(formData);
          Toast.success("背景画像がアップロードしました");

          RefreshUserInfo().then((res2) => {
            const userInfo = res2.data.data.user;
            localStorage.setItem(
              process.env.VUE_APP_USER_KEY,
              JSON.stringify(userInfo)
            );
          });
        })
        .catch((err) => {
          // 处理失败会执行
          console.log(err);
        })
        .always(() => {
          // 不管是成功失败，都会执行
        });
    },
    calcQuality(size) {
      const targetSize = 1048576; // 1M大小
      const maxSize = 10485760; // 10MB大小
      let quality = 1;

      if (size < targetSize) {
        return quality; // 如果文件小于1M，保持原始质量
      } else if (size > maxSize) {
        return quality; //如果文件大于10M，则不压缩，质量因子为1
      } else {
        quality = targetSize / size;
        // 如果文件大小在1M和10M之间，则计算出压缩质量，使得压缩后文件大小为1M
      }
      // 确保质量在0.1到1之间
      return Math.max(Math.min(quality, 1), 0.1);
    },
    updateUserFile(file) {
      this.filename = file.name;
      this.file = file;

      let quality = this.calcQuality(file.size);
      this.compressImg(file, 0.7);

      // let formData = new FormData();
      // formData.append("file", file);
      // uploadBackground(formData);
    },
    uploadBackground(file) {
      this.filename = file.file.name;
      this.file = file.file;
    },
    validatorAutoAnswerTime(value) {
      return /^([0-9]{1,2}|60)$/.test(value);
    },
    initUserInfo() {
      GetUserDetails().then((res) => {
        this.userInfo = res.data.data.detail;

        this.setUserInfoStatus("answer_flg", this.userInfo.answer_flg);
        this.setUserInfoStatus("camera_flg", this.userInfo.camera_flg);
        this.setUserInfoStatus("audio_flg", this.userInfo.audio_flg);
        this.setAuth(this.userInfo.auth_type);
        this.setUserInfoStatus("audio_bridge", this.userInfo.audio_bridge);
        this.setUserInfoStatus("autopush_flg", this.userInfo.autopush_flg);
        this.setUserInfoStatus(
          "monitor_open_flg",
          this.userInfo.monitor_open_flg
        );
        this.setUserInfoStatus("time_show_flg", this.userInfo.time_show_flg);
        this.setUserInfoStatus(
          "self_view_flg",
          this.userInfo.self_view_flg == null || this.userInfo.self_view_flg === ""
            ? 1
            : this.userInfo.self_view_flg
        );
        this.setUserInfoStatus("no_answer_flg", this.userInfo.no_answer_flg);
        this.setUserInfoStatus(
          "show_call_no_answer_flg",
          this.userInfo.show_call_no_answer_flg
        );

        this.is_full_screen_call = this.userInfo.is_full_screen_call == 1;

        this.filename = this.userInfo.filename;
        this.isInfoBack = true;
        this.$forceUpdate();
        GetRingingList().then((res) => {
          this.ringColumns = res.data.data.list;
          this.defaultIndex = this.getCheckedIndex(this.userInfo.ringing_id);
        });
      });
    },
    setUserInfoStatus(key, value) {
        const keyToBooleanMap = {
          answer_flg: "checkInfo",
          camera_flg: "checkCamera",
          audio_flg: "checkAudio",
          self_view_flg: "checkSelfView",
          audio_bridge: "checkAudioBridge",
          autopush_flg: "checkAutopushflg",
          monitor_open_flg: "checkMonitorOpenFlg",
          time_show_flg: "checkTimeShowFlg",
          no_answer_flg: "noAnswerFlg",
        show_call_no_answer_flg: "showCallNoAnswerFlg",
      };

      // if (keyToBooleanMap.hasOwnProperty(key)) {
      if (Object.prototype.hasOwnProperty.call(keyToBooleanMap, key)) {
        this[keyToBooleanMap[key]] = value == 1 ? true : false;
      }
    },
    setAuth(status) {
      if (status === "email" || status === "sms" || status === "line") {
        this.authInfo = true;
        this.authType = status;
      } else {
        this.authInfo = false;
      }
    },
    async chooseBg() {
      if (!this.filename && !this.file) {
        Toast.fail("背景画像がアップロードできませんでした");
        this.cancelChooseBg();
        return;
      }

      console.log(this.file);

      if (!this.checkFileSize(this.file)) {
        this.cancelChooseBg();
        return;
      }

      this.updateUserFile(this.file);
    },
    getCheckedIndex(id) {
      const index = this.ringColumns.findIndex((item) => item.id === id);
      return index !== -1 ? index : 0;
    },
    handleChangeUserInfo: _.debounce(function (type, value) {
      const detail = {
        id: this.userInfo.id,
        [type]: Number(value),
        autopush_flg: this.checkAutopushflg === true ? 1 : 0,
      };
      UpdateUser(detail).then((res) => {
        if (res.data.code < 0) {
          Toast.fail("変更に失敗しました");
        } else {
          RefreshUserInfo().then((res) => {
            const userInfo = res.data.data.user;
            localStorage.setItem(
              process.env.VUE_APP_USER_KEY,
              JSON.stringify(userInfo)
            );
          });
        }
      });
    }, 500),
    onClickLeft() {
      history.back();
    },
    goToPage(pageName, params = {}) {
      const routes = {
        password: "/userPasswordVerify",
        userRinging: { path: "/userRinging", query: params },
        authentication: "/authentication",
        userInfo: "/userInfo",
        waitBackground: "/waitBackground",
        timeDisplaySize: "/timeDisplaySize",
        fullScreenCallDisplaySize: "/fullScreenCallDisplaySize",
        patientWaitBackground: "/patientWaitBackground",
        PatientListBinah: "/PatientListBinah",
        monitorRoom: () => {
          return { path: "/monitorRoom", query: { type: "startMonitor" } };
        },
        webSpeech: "/webSpeech",
        ringingChoose: () => {
          return {
            path: "/ringingChoose",
            query: {
              id: this.userInfo.id,
              ringing_id: this.userInfo.ringing_id,
            },
          };
        },
        ringingMsgChoose: () => {
          return {
            path: "/ringingMsgChoose",
            query: {
              id: this.userInfo.id,
              ringing_id: this.userInfo.ringing_id_msg,
            },
          };
        },
        binahData: () => {
          return {
            path: "/binahData",
            query: {
              patient_id: this.userInfo.patient_id,
              login_id: this.userInfo.login_id,
            },
          };
        },
        // dzPage: "/dzPage",
      };
      const route = routes[pageName];
      if (typeof route === "function") {
        this.$router.push(route());
      } else {
        this.$router.push(route);
      }
    },
    handleBeforeChange(value) {
      if (value > 60) {
        Toast.fail("最大値は60です");
        return false;
      } else if (value < 0) {
        Toast.fail("最小値は0です");
        return false;
      }
      return true;
    },
    toggleDarkMode(value) {
      this.darkModeType = value;
      localStorage.setItem("darkModeType", value);
    },
    toggleShowCallIcon(value) {
      this.showCallIcon = value;
      localStorage.setItem("showCallIcon", JSON.stringify(value));
      if (!value) {
        this.is_full_screen_call = true;
        this.handleChangeUserInfo("is_full_screen_call", true);
      }
    },
    iosOrAndroid() {
      //由于添加了PC端域名，所以这里可以使用域名的方式来判断了。不再使用userAgent。为了避免模拟器修改userAgent的情况
      let url = window.location.href;
      if (url.indexOf("ios") !== -1) {
        console.log("URL contains 'ios'");
        this.isIos = true;
      } else {
        console.log("URL does not contain 'ios'");
        this.isIos = false;
      }
    },
  },
};
</script>

<style scoped>
.van-field__label {
  width: 115px;
  font-size: 16px;
}
.cell_style {
  margin: 0px;
  border: 1px solid #dfe1e4;
}
.form_style {
  width: 100%;
  max-width: 500px;
  margin-top: 20px;
}
.mypage-income-btnArea {
  display: flex;
  justify-content: space-between;
  div {
    font-size: 18px;
    font-weight: bold;
    padding: 15px;
  }
}
.mypage-income-contentArea {
}
.log-container {
  max-height: 300px; /* 设置最大高度 */
  overflow-y: auto; /* 启用垂直滚动 */
  padding: 10px; /* 内边距 */
}

:deep(.time-display-size-field .van-field__label) {
  white-space: nowrap;
}
</style>
